export const selectUrl = () => {
  switch (process.env.REACT_APP_ENV) {
    case "dev":
      return "http://localhost:4000";
    case "prod":
      return "https://geequip-api.sistemasgap.com.br";
    default:
      return "http://localhost:4000";
  }
};
